import { useQuery } from '@tanstack/react-query';
import { searchService } from './search.service';

const useProducts = (keyword: string, isStorePage: boolean) => {
  return useQuery({
    queryKey: ['products', keyword],
    queryFn: () => searchService.fetchProducts(keyword),
    enabled: !!keyword && !isStorePage, // Only run the query if keyword is provided,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};

export default useProducts;
